import { render, staticRenderFns } from "./Template8.vue?vue&type=template&id=199c3ce5&scoped=true&"
import script from "./Template8.vue?vue&type=script&lang=js&"
export * from "./Template8.vue?vue&type=script&lang=js&"
import style0 from "./Template8.vue?vue&type=style&index=0&id=199c3ce5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199c3ce5",
  null
  
)

export default component.exports